module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "move"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetails),
      expression: "showDetails"
    }],
    ref: "detailsWrapper",
    staticClass: "detailsWrapper"
  }, [_c('div', {
    staticClass: "foodDetails"
  }, [_c('div', {
    staticClass: "back",
    on: {
      "click": _vm.showToggle
    }
  }, [_c('i', {
    staticClass: "icon-arrow_lift"
  })]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.food.image,
      "height": "425",
      "width": "100%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.food.name))]), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('span', [_vm._v("月售" + _vm._s(_vm.food.sellCount) + "份")]), _vm._v(" "), _c('span', [_vm._v("好评率" + _vm._s(_vm.food.rating) + "%")])]), _vm._v(" "), _c('div', {
    staticClass: "price"
  }, [_c('span', {
    staticClass: "unit"
  }, [_vm._v("￥")]), _vm._v(_vm._s(_vm.food.price) + "\n          "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.oldPrice),
      expression: "food.oldPrice"
    }],
    staticClass: "oldPrice"
  }, [_vm._v("￥" + _vm._s(_vm.food.oldPrice))])]), _vm._v(" "), _c('div', {
    staticClass: "shopCart"
  }, [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isFoodInCart),
      expression: "!isFoodInCart"
    }],
    staticClass: "text",
    on: {
      "click": function($event) {
        _vm.addToCart({
          food: _vm.food
        })
      }
    }
  }, [_vm._v("加入购物车")])])], 1), _vm._v(" "), _c('cart-control', {
    attrs: {
      "food": _vm.food
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("商品介绍")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v(_vm._s(_vm.food.info))])]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('evaluation', {
    attrs: {
      "ratings": _vm.food.ratings
    },
    on: {
      "refreshEval": _vm.refreshScroll
    },
    scopedSlots: _vm._u([{
      key: "evalDetails",
      fn: function(props) {
        return [_c('li', {
          staticClass: "eval"
        }, [_c('div', {
          staticClass: "userInfo"
        }, [_c('div', {
          staticClass: "time"
        }, [_vm._v(_vm._s(_vm._f("time")(props.eval.ratingTime)))]), _vm._v(" "), _c('div', {
          staticClass: "user"
        }, [_c('span', [_vm._v(_vm._s(props.eval.username))]), _vm._v(" "), _c('span', {
          staticClass: "avatar"
        }, [_c('img', {
          attrs: {
            "src": props.eval.avatar,
            "width": "12",
            "height": "12"
          }
        })])])]), _vm._v(" "), _c('div', {
          staticClass: "content"
        }, [_c('span', {
          staticClass: "icon",
          class: props.eval.rateType ? 'icon-thumb_down' : 'icon-thumb_up'
        }), _vm._v(" "), _c('span', {
          staticClass: "text"
        }, [_vm._v(_vm._s(props.eval.text))])])])]
      }
    }])
  }, [_c('template', {
    slot: "evalName"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("商品评价")])])], 2)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe929b98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FoodDetails.vue
// module id = 246
// module chunks = 1